// extracted by mini-css-extract-plugin
module.exports = {"approveIcon":"ReservationList_approveIcon__35vai","rejectIcon":"ReservationList_rejectIcon__1Vv8W"};